/**
 * Base classes for the component.
 * @type {string}
 */
export const BASE_CLASS = 'orca-combo-box';

/**
 * Class for the container element.
 * @type {string}
 */
export const CONTAINER_CLASS = 'orca-combo-box-container';

/**
 * Class to indicate an error.
 * @type {string}
 */
export const ERROR_CLASS = 'orca-combo-box-error';

/**
 * Base classes for the component.
 * @type {object}
 * @property {string} top - top position.
 * @property {string} auto - auto position (depending on parent container height).
 * @property {string} bottom - bottom position.
 */
export const MENU_PLACEMENTS = {
    TOP: 'top',
    AUTO: 'auto',
    BOTTOM: 'bottom'
};
